import { createAction, createSlice } from '@reduxjs/toolkit';

import { initialStore } from '../initial-store';

export const getOperators = createAction('operators/GET_OPERATORS');

const operatorsSlice = createSlice({
  initialState: initialStore.operatorsPage,
  name: 'operatorsPage',
  reducers: {
    removeOperator: (state, { payload }) => {
      state.data = state.data.filter((item) => item.id !== payload.id);
    },
    setLoading: (state, { payload }) => {
      state.isLoading = payload;
    },
    setOperators: (state, { payload }) => {
      const { count, result } = payload;
      state.data = result;
      state.count = count;
      state.isLoading = false;
    },
    updateOperator: (state, { payload }) => {
      state.data = state.data.map((item) => {
        if (item.id === payload.id) {
          return payload;
        }
        return item;
      });
    }
  }
});

export const { removeOperator, setLoading, setOperators, updateOperator } =
  operatorsSlice.actions;

export const { reducer } = operatorsSlice;
